// extracted by mini-css-extract-plugin
export default {"modal":"premium_modal__Iusob","modalContent":"premium_modalContent__yihO7","upgradeButton":"premium_upgradeButton__DJ+Vj","cancelButton":"premium_cancelButton__ZzMCo"};